<div class="main-background">

    <app-toaster/>

<!--  TODO: check this as well  @if (isNavigating()) {-->
    @if (blurActive) {
        <div class="loading-overlay">
            <div class="spinner"></div>
        </div>
    }
    <router-outlet/>
</div>
